import Carousel from './Carousel.jsx'

export default Carousel
